(function(){
    'use strict';

    function openMobileMenu() {
        $smpLower.addClass('open');
        $smpMobileBtn.attr("aria-expanded", "true");
        $("body").addClass("mobile-menu--active"); // Overflow hidden won't work on certain mobile devices. User can still scroll the header and close the menu if position: fixed on body isnt used
    }    

    function closeMobileMenu() {

        $smpLower.removeClass('open');
        $smpHeader.removeClass("smp-header--fixed");
        $smpMobileBtn.attr("aria-expanded", "false").removeClass("active");
        $("body").removeClass("mobile-menu--active");
    }

    var $smpHeader = $('.smp-header');
    var $smpLower = $smpHeader.find('.smp-header__lower');
    var $smpMobileBtn = $('.smp-header__mobile-btn');

    if($smpHeader.length){

        $smpMobileBtn.on("click", function() {

            var $cur = $(this);
            var btnToggle = squiz.fn.smpToggleBtn($cur);

            if(!btnToggle) {

                openMobileMenu();

            } else {

                closeMobileMenu();

            }

        });

        $(window).on("resize", function() {

            closeMobileMenu();
            squiz.fn.smpClearNavItemState('.smp-navigation-mega__sub-outer', '.smp-navigation-mega__item-title');

        });

    }

}());
